// Dependencies
import React, { Component } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton
} from "react-share";

// Components & Containers
import "./style.css";
import { CoinCard } from "../../components/Card";

export default class Donate extends Component {
  render() {
    let { title, description, warningText, bottomText, donations } = this.props;

    donations = donations.sort((a, b) => a.position - b.position);

    return (
      <div className="donateContainer" id="Donate">
        <div className="donateContainer__title">{title}</div>
        <div className="donateContainer__subtitle">{description}</div>
        <div className="donateContainer__warning">{warningText}</div>
        <div className="cardsContainer">
          {donations.map(donation => (
            <CoinCard
              key={donation._id}
              bitcoinText={this.props.bitcoinText}
              donationData={donation}
            />
          ))}
        </div>
        <div className="donateContainer__message">{bottomText}</div>
        <div className="shareButtons">
          <FacebookShareButton
            title={this.props.facebookQuote}
            url="https://airdropvenezuela.org/"
            className="shareButtons__btn"
          >
            <span className="shareButtons__btn--facebook">
              {this.props.facebook}
            </span>
          </FacebookShareButton>
          <TwitterShareButton
            title={this.props.twitterQuote}
            url="https://airdropvenezuela.org/"
            className="shareButtons__btn"
          >
            <span className="shareButtons__btn--twitter">
              {this.props.twitter}
            </span>
          </TwitterShareButton>
          <WhatsappShareButton
            title={this.props.whatsappQuote}
            url="https://airdropvenezuela.org/"
            className="shareButtons__btn"
          >
            <span className="shareButtons__btn--whatsapp">
              {this.props.whatsapp}
            </span>
          </WhatsappShareButton>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Donate/index.jsx